import createReducer from 'common/redux/utils/createReducer';
import { Map } from 'immutable';
import keyBy from 'lodash.keyby';
import { RECEIVE_FUNNEL } from 'funnel/actions/funnel';
import * as actions from 'funnel/actions/product';

const getInitialState = {};

const products = createReducer(getInitialState, {
  [RECEIVE_FUNNEL](state, { funnel, products }) {
    const isProductSelected = product =>
      funnel.products.findIndex(
        p => p.id.toString() === product.id.toString()
      ) > -1;

    // Checking for selected products
    const selected = products.map(p => {
      return {
        ...p,
        active: isProductSelected(p),
      };
    });

    return {
      ...state,
      items: Map(keyBy(selected, 'id')),
    };
  },
  [actions.TOGGLE_PRODUCT](state, { product }) {
    const items = state.items.update(product.toString(), p => {
      return {
        ...p,
        active: !p.active,
      };
    });

    return {
      ...state,
      items,
    };
  },
});

export default products;



// WEBPACK FOOTER //
// ./src/modules/funnel/reducers/products.js